// to formate date strings
const formatDate = (iso) => {
  if (!iso) return "Not available";
  try {
    return new Date(iso).toLocaleDateString("cs-CZ", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });
  } catch {
    return "Not available";
  }
};

export default formatDate;
